export default __webpack_public_path__ + "static/bulkVp5-0adc9b1cf078ad7bfb66357c0df51d87.png";